import React, { useState } from 'react'
import { CompanyCardSkeletonShimmer } from '../../../Utils/skeletonLoader/CompanyCardSkeletonShimmer'
import { CompanyCardView } from '../../../CommonComponents/CompanyCardView'
import DeleteModal from '../../DeleteModal'
import EditCompanyOffcanvas from '../../../CommonComponents/EditCompanyOffcanvas'
import { Container } from 'react-bootstrap'
import useLocalStorageState from 'use-local-storage-state'
import { DeleteRequest, GetRequest } from '../../../Utils/hooks/ApiHandler'
import { toast } from 'sonner'
import { CompanyTableListing } from './CompanyTableListing'

export const CompanyListing = ({
    isLoading,
    columnOptions,
    columns,
    highlightId,
    data,
    viewMode,
    refetchCompanies,
    tempFilterData,
    limit,
    setLimit,
    headers,
    extras,
    activeOffset,
    setActiveOffset,
    totalCompanies,
}) => {
    const [customer, setCustomer] = useLocalStorageState('customer')
    const customer_id = customer?.customer_details?.customer_id;
    const user_login_id = customer?.customer_details?.id;
    // delete modal loading state
    const [loading, setLoading] = useState(false)
    // company id to delete
    const [confirmDeleteId, setConfirmDeleteId] = useState(null)
    // company id to edit
    const [editCompanyId, setEditCompanyId] = useState(null)
    // fetching the selected company details and storing data in below state and later passing
    const [companyData, setCompanyData] = useState(null)
    // company edit offcanvas
    const [showOffcanvas, setShowOffcanvas] = useState(false)

    const [isOwnerSame, setIsOwnerSame] = useState(false)

    // Updated dataToDisplay logic
    const dataToDisplay = tempFilterData !== null ? tempFilterData.data : data
    const hasDataToDisplay = dataToDisplay?.length > 0

    // Calculate total pages based on dataToDisplay
    const isFiltered = tempFilterData !== null
    const pageCount = Math.ceil(totalCompanies / limit) || 0

    const effectivePageCount = isFiltered
        ? Math.ceil((tempFilterData?.total_count || 0) / limit) || 0
        : pageCount

    // Pagination display calculations
    const totalItems = isFiltered
        ? (tempFilterData?.total_count || 0)
        : (totalCompanies || 0)

    const displayStartItem = totalItems === 0
        ? 0
        : activeOffset * limit + 1

    const displayEndItem = totalItems === 0
        ? 0
        : Math.min(activeOffset * limit + limit, totalItems)


    // export data function and states
    const handlePageChange = (selectedItem) => {
        setActiveOffset(selectedItem.selected)
    }

    const fetchCompanyDetails = async (id) => {
        try {
            const res = await GetRequest(
                `company/getCompanyDetails/${id}/${customer?.customer_details?.customer_id}/${customer?.customer_details?.id}`,
                { headers },
                extras
            )
            console.log('res', res)
            if (res?.status === "fail" || res.success === false) {
                return
            }
            if (
                customer?.customer_details?.user_type === "1"
            ) {
                setIsOwnerSame(true)
            } else if (user_login_id === res?.data[0]?.owner_id) {
                setIsOwnerSame(true)
            } else {
                setIsOwnerSame(false)
            }
            setCompanyData(res.data[0])
            setEditCompanyId(id)
            setShowOffcanvas(true)
        } catch {
            // toast.error("Something went wrong")
            return
        }
    }


    const handleDeleteCompany = async (id) => {
        setLoading(true)
        try {
            const res = await DeleteRequest(
                `company/deleteCompany/${id}/${customer?.customer_details?.customer_id}/${customer?.customer_details?.id}`,
                { headers },
                extras
            )
            //  Always close the popup
            setConfirmDeleteId(null)

            if (res?.success === false || res?.status === "fail") {
                setLoading(false)
                toast.warning(res?.message || "Company associated to contact")
                return
            }
            setLoading(false)
            toast.success(res.message || "Deleted successfully")
            refetchCompanies() // Refresh the company list
        } catch (err) {
            //  Close popup even on error
            setLoading(false)
            setConfirmDeleteId(null)
            // toast.error(err.message || "Delete error")
        }
    }

    return <>
        {
            viewMode === "card" ? (
                <>
                    <hr />
                    {isLoading ?
                        <CompanyCardSkeletonShimmer />
                        :
                        <CompanyCardView
                            dataToDisplay={dataToDisplay}
                            hasDataToDisplay={hasDataToDisplay}
                            pageCount={effectivePageCount}
                            limit={limit}
                            setLimit={setLimit}
                            offset={activeOffset}
                            handlePageChange={handlePageChange}
                            fetchCompanyDetails={fetchCompanyDetails}
                            setConfirmDeleteId={setConfirmDeleteId}
                            setOffset={setActiveOffset}
                            customer={customer}
                            displayStartItem={displayStartItem}
                            displayEndItem={displayEndItem}
                            totalItems={totalItems}
                        />
                    }
                </>
            )
                :
                (
                    <CompanyTableListing
                        isLoading={isLoading}
                        highlightId={highlightId}
                        dataToDisplay={dataToDisplay}
                        hasDataToDisplay={hasDataToDisplay}
                        columnOptions={columnOptions}
                        columns={columns}
                        limit={limit}
                        setLimit={setLimit}
                        activeOffset={activeOffset}
                        setActiveOffset={setActiveOffset}
                        effectivePageCount={effectivePageCount}
                        totalItems={totalItems}
                        displayStartItem={displayStartItem}
                        displayEndItem={displayEndItem}
                        handlePageChange={handlePageChange}
                        fetchCompanyDetails={fetchCompanyDetails}
                        setConfirmDeleteId={setConfirmDeleteId}
                    />
                )
        }


        {showOffcanvas && (
            <EditCompanyOffcanvas
                show={true}
                company_data={companyData}
                isOwnerSame={isOwnerSame}
                setShow={() => setShowOffcanvas(false)}
                fetchData={refetchCompanies}
            />
        )}

        {confirmDeleteId && (
            <DeleteModal
                show={true}
                onConfirm={() => handleDeleteCompany(confirmDeleteId)}
                onClose={() => setConfirmDeleteId(null)}
                isLoading={loading}
                companyName={
                    dataToDisplay.find((c) => c.id === confirmDeleteId)?.company_name ||
                    ""
                }
                message={"Are you sure to permanent delete this company !!"}
            />
        )}


    </>
}
